import React from 'react';
import { connect } from 'react-redux';
import { Field, formValues } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { Checkbox, Input } from '../../../common/components/formControls';
import validators from '../../../common/services/validators';
import authUtils from '../../../auth/utils';

// redux-form compares validators by reference, so they must not be rebuilt on every render
const settlementReferenceValidators = [validators.required, validators.maxLength(255)];

// lets the admin record a refund that has already been paid back to the parent, rather than leaving it owed on the credit notes report.
// Only where refunds are tracked (franchisors with subscription compliance enabled - for the rest refunds are taken as paid back when
// recorded), and for users who can mark refunds as paid back.
const PaidBackFields = ({ canMarkPaidBack, paidBack, t }) => canMarkPaidBack ?
	<React.Fragment>
		<Field name='paidBack' component={Checkbox} horizontal label={t('CancellationCreditNote_AlreadyPaidBack')}
			help={t('CancellationCreditNote_AlreadyPaidBack_Help')} normalize={v => !!v} />
		{paidBack && <Field name='settlementReference' component={Input} horizontal required label={t('CancellationCreditNote_SettlementReference')}
			validate={settlementReferenceValidators} />}
	</React.Fragment> : null;

const mapStateToProps = ({ configuration: { franchisor }, auth: { currentUser } }) => ({
	canMarkPaidBack: !!franchisor.isSubscriptionComplianceEnabled && authUtils.hasPermission(currentUser, 'MarkAsPaid')
});

export default connect(mapStateToProps)(formValues('paidBack')(withTranslation()(PaidBackFields)));
